import { render, staticRenderFns } from "./AuthRegister.vue?vue&type=template&id=d78a7f60&scoped=true&lang=pug&"
import script from "./AuthRegister.vue?vue&type=script&lang=js&"
export * from "./AuthRegister.vue?vue&type=script&lang=js&"
import style0 from "./AuthRegister.vue?vue&type=style&index=0&id=d78a7f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78a7f60",
  null
  
)

export default component.exports